export default class OrderResponse {
    pedido          = "";
    valorTotal      = 0;
    qtnParcela      = "";
    id              = "";
    formaPagamento  = "Cartão de crédito";
    itemPedido      = "";
    mensagem        = "";

    

    constructor(pedido, valorTotal, qtnParcela, id, itemPedido, mensagemitem){
        this.pedido = pedido;
        this.valorTotal = valorTotal;
        this.qtnParcela = qtnParcela;
        this.id = id;
        this.itemPedido = itemPedido;
        this.mensagem = mensagemitem;
    }





    getIdPedido() { return this.pedido; }

    getValorTotal() { return this.valorTotal; }

    getQtnParcela() { return this.qtnParcela; }
}